"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMediaQuery = void 0;
const react_1 = require("react");
function useMediaQuery(query) {
    const [result, setResult] = react_1.useState(window.matchMedia ? window.matchMedia(query).matches : true);
    react_1.useLayoutEffect(() => {
        if (!window.matchMedia) {
            return () => { };
        }
        const handler = (e) => {
            setResult(e.matches);
        };
        const mediaQuery = window.matchMedia(query);
        mediaQuery.addListener(handler);
        setResult(mediaQuery.matches);
        return () => {
            mediaQuery.removeListener(handler);
        };
    }, [query, setResult]);
    return result;
}
exports.useMediaQuery = useMediaQuery;
//# sourceMappingURL=useMediaQuery.js.map